export function Anchor(props) {
  return <a {...props} />;
}
